export class PortfolioItem {

  constructor(public id: number,public HeadDescription: string, public fieldDescription: string, public fullDescription: string,
  public summaryBy: string, public summaryDate: string, public summarySkills: string, public client: string, public contentPicsPaths: string[]){
  }

}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/portfolio/portfolio-item.ts